import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Classes({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2.5 -3 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21.628135 5.35098673c0 2.13413636-1.7325 3.86425-3.86958 3.86425-2.13774 0-3.87024-1.73011364-3.87024-3.86425 0-2.13413637 1.7325-3.86425 3.87024-3.86425 2.13708 0 3.86958 1.73011363 3.86958 3.86425zM9.41945357 10.09201725c0 1.82897725-1.485 3.31259095-3.3165 3.31259095-1.83216 0-3.31716-1.4836137-3.31716-3.31259095 0-1.82897728 1.485-3.31259091 3.31716-3.31259091 1.8315 0 3.3165 1.48361363 3.3165 3.31259091zM32.7311184 10.09201725c0 1.82897725-1.485 3.31259095-3.31716 3.31259095-1.8315 0-3.3165-1.4836137-3.3165-3.31259095 0-1.82897728 1.485-3.31259091 3.3165-3.31259091 1.83216 0 3.31716 1.48361363 3.31716 3.31259091zM23.701261 19.0631672c0-3.3541136-2.7225-6.0728636-6.08124-6.0728636-3.35808 0-6.08124 2.71875-6.08124 6.0728636 0 .0777728.00924.1529091.01188.2300228l-.01188 13.5736396h12.16248V19.29319c-.00924-.0771137 0-.15225 0-.2300228zM6.57142871 16.9999997c-3.35874 0-5.12120971 2.7194091-5.12120971 6.0728637 0 .0777727.00858 3.4655.01122 3.5426136l-.01122 4.1888441h5.12120971M28.7142859 16.9999997c3.35874 0 5.0760651 2.7194091 5.0760651 6.0728637 0 .0777727-.00924 3.4655-.01188 3.5426136l.01188 4.1888441h-5.0760651" />
      </g>
    </svg>
  )
}

Classes.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
